import { useState, useRef } from 'react';
import { auth, toEmail, signInWithEmailAndPassword } from '../firebase/config';

export default function Login() {
  const [phone, setPhone] = useState('');
  const [pass,  setPass]  = useState('');
  const [err,   setErr]   = useState('');
  const [loading, setLoading] = useState(false);

  const phoneRef = useRef(null);
  const passRef  = useRef(null);

  const submit = async e => {
    e?.preventDefault();
    // Read directly from DOM — password managers (Touch ID, 1Password etc.) inject
    // values into the DOM without always triggering React's onChange, so React state
    // can be empty even when the field visually shows a value.
    const phoneVal = phoneRef.current?.value || phone;
    const passVal  = passRef.current?.value  || pass;
    if (!phoneVal || !passVal) { setErr('Please enter your phone and password.'); return; }
    setErr(''); setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, toEmail(phoneVal), passVal);
    } catch {
      setErr('Incorrect phone number or password.');
    }
    setLoading(false);
  };

  return (
    <div id="authScreen" style={{position:'relative',overflow:'hidden'}}>
      {/* Floating gradient blobs — gives the glass card something to blur against */}
      <div style={{position:'fixed',inset:0,zIndex:0,pointerEvents:'none'}}>
        <div style={{position:'absolute',width:520,height:520,borderRadius:'50%',
          background:'radial-gradient(circle, rgba(76,61,143,0.28) 0%, transparent 70%)',
          top:'-120px',left:'-140px',filter:'blur(40px)'}}/>
        <div style={{position:'absolute',width:420,height:420,borderRadius:'50%',
          background:'radial-gradient(circle, rgba(176,125,58,0.22) 0%, transparent 70%)',
          bottom:'-80px',right:'-100px',filter:'blur(40px)'}}/>
        <div style={{position:'absolute',width:300,height:300,borderRadius:'50%',
          background:'radial-gradient(circle, rgba(99,89,200,0.18) 0%, transparent 70%)',
          top:'45%',left:'60%',filter:'blur(35px)'}}/>
        {/* Subtle noise texture via repeating dots */}
        <div style={{position:'absolute',inset:0,opacity:0.025,
          backgroundImage:'radial-gradient(circle, #4C3D8F 1px, transparent 1px)',
          backgroundSize:'28px 28px'}}/>
      </div>

      {/* Card */}
      <div style={{position:'relative',zIndex:1}} className="lyt-auth-card">
        {/* Logo + branding */}
        <div style={{textAlign:'center',marginBottom:28}}>
          <div style={{
            width:68,height:68,borderRadius:20,margin:'0 auto 14px',
            background:'rgba(255,255,255,0.72)',
            boxShadow:'6px 6px 16px rgba(76,61,143,0.14), -4px -4px 12px rgba(255,255,255,0.90), inset 0 1px 0 rgba(255,255,255,1)',
            display:'flex',alignItems:'center',justifyContent:'center',
            border:'1.5px solid rgba(255,255,255,0.80)',
          }}>
            <img src="/logo.png" alt="TOF" style={{width:46,height:46,objectFit:'contain'}}/>
          </div>
          <div style={{fontSize:'calc(var(--fs) + 6px)',fontWeight:800,color:'var(--lyt-t1)',letterSpacing:-0.5,marginBottom:3}}>
            True Origin Foods
          </div>
          <div style={{fontSize:'calc(var(--fs) - 2px)',color:'var(--lyt-t4)',fontWeight:500,letterSpacing:0.4,textTransform:'uppercase'}}>
            Operations Platform
          </div>
        </div>

        {/* Neumorphic divider */}
        <div style={{height:1,background:'linear-gradient(90deg,transparent,rgba(76,61,143,0.12),transparent)',marginBottom:24}}/>

        <form onSubmit={submit}>
          <div className="lyt-fg">
            <label htmlFor="phone">Phone / ID</label>
            <input ref={phoneRef} type="text" value={phone}
              onChange={e=>setPhone(e.target.value)}
              onInput={e=>setPhone(e.target.value)}
              placeholder="Phone number" autoComplete="username" id="phone"/>
          </div>
          <div className="lyt-fg">
            <label htmlFor="password">Password</label>
            <input ref={passRef} type="password" value={pass}
              onChange={e=>setPass(e.target.value)}
              onInput={e=>setPass(e.target.value)}
              autoComplete="current-password" id="password"/>
          </div>
          {err && <div className="lyt-err">{err}</div>}
          <button className="lyt-btn lyt-btn-dark lyt-btn-full"
            style={{marginTop:20,padding:'13px',fontSize:'var(--fs)',letterSpacing:0.1,
              boxShadow:'0 4px 20px rgba(76,61,143,0.35), inset 0 1px 0 rgba(255,255,255,0.15)'}}
            disabled={loading} type="submit">
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        {/* Bottom watermark */}
        <div style={{textAlign:'center',marginTop:22,fontSize:'calc(var(--fs) - 3px)',color:'var(--lyt-t4)',letterSpacing:0.3}}>
          Coimbatore · {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
